import React from 'react';
import { Box, Center, Flex, Skeleton, Grid, GridItem } from '@chakra-ui/react';

const CourseSkeleton = () => {
  return (
    <Box>
      <Flex mb="20px" mt="100px" p={4}>
        {/* Sidebar */}
        <Box w="300px" pr={4}>
          <Center>
            <Skeleton mt={4} h="20px" w="60%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          <Center>
            <Skeleton h="20px" w="80%" />
          </Center>
          {/* ... Repeat for other categories */}
        </Box>

        {/* Right Section */}
        <Box flex="1" bg="gray.100" p={4}>
          <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={6}>
            {[1, 2, 3, 4, 5].map((index) => (
              <GridItem key={index}>
                <Box
                  bg="white"
                  borderRadius="md"
                  boxShadow="md"
                  p={4}
                >
                  <Skeleton height="120px" mb={2} />
                  <Skeleton height="20px" width="80%" mb={2} />
                  <Skeleton height="15px" width="60%" mb={2} />
                  <Skeleton height="15px" width="40%" />
                </Box>
              </GridItem>
            ))}
          </Grid>
        </Box>
      </Flex>
    </Box>
  );
};

export default CourseSkeleton;
